import { Directive, Input, ViewContainerRef } from '@angular/core';
import { LoadingAnimationDirectiveContainerComponent } from './loading-animation-directive-container/loading-animation-directive-container.component';

@Directive({
	// We need to disable linter here because it does not expect directive to be bound to ngIf directive
	/* eslint-disable */
	selector: '[ngIfAppLoadingAnimation]',
})
// You need to import ngIf directive into the standalone component before bcs this on is dependent on it
export class LoadingAnimationDirective {
	@Input() set ngIf(val: any) {
		if (!val) {
			this.vcRef.createComponent(LoadingAnimationDirectiveContainerComponent);
		}
	}

	constructor(private vcRef: ViewContainerRef) {}
}
